import * as React from "react"
import type { SVGProps } from "react"
const SvgPersonalization = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M18 13.14q.42 0 .71-.28a1 1 0 0 0 .29-.72 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-3a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .43.29.72t.71.28zm0-3q.42 0 .71-.28a1 1 0 0 0 .29-.72 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-3a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .43.29.72t.71.28zm-9 3q-.9 0-1.62.17a4 4 0 0 0-1.28.5q-.53.33-.8.75a1.6 1.6 0 0 0-.28.88q0 .3.23.5.22.2.55.2h6.4q.33 0 .55-.21a.7.7 0 0 0 .23-.54q0-.42-.28-.82a3 3 0 0 0-.8-.75 4 4 0 0 0-1.28-.51A8 8 0 0 0 9 13.14m0-1q.82 0 1.41-.58.6-.6.59-1.42 0-.82-.59-1.41A2 2 0 0 0 9 8.14q-.82 0-1.41.59A2 2 0 0 0 7 10.14q0 .82.59 1.42.59.58 1.41.58m-5 8q-.82 0-1.41-.58A2 2 0 0 1 2 18.13v-12q0-.82.59-1.41A2 2 0 0 1 4 4.14h16q.83 0 1.41.59.6.6.59 1.41v12q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h16v-12H4z" />
  </svg>
)
export default SvgPersonalization
